import { fetcher } from "services/api.service";
import useSWR from "swr";
import { LogisticsTicket } from "types/logisticsTicket";

type UseLogisticsTicketsArgs = {
  search?: string;
  pageSize?: number;
  filters?: string[];
  enabled?: boolean;
};

export default function useLogisticsTickets({
  search,
  pageSize,
  filters,
  enabled = true,
}: UseLogisticsTicketsArgs = {}) {
  const params = new URLSearchParams();
  if (search) {
    params.set("q", search);
  }
  if (pageSize) {
    params.set("page[size]", String(pageSize));
  }
  filters?.forEach((filter) => {
    params.append("filter[]", filter);
  });
  const query = params.toString();
  const key = enabled ? (query ? `/logistics_tickets?${query}` : "/logistics_tickets") : null;

  const { data, isLoading, error, mutate } = useSWR<{ tickets: LogisticsTicket[] }>(key, fetcher);

  return {
    logisticsTickets: data?.tickets || [],
    isLoading,
    error,
    refetch: mutate,
  };
}
